<div class="users layout-spacing">
    <!-- Content to be projected into the sub-navbar component -->
    <ng-template #subNavBarContent>
        <div class="nav-bar__container">
            @if (showNewUserButton()) {
                <app-button
                    label="New User"
                    iconKey="chevron-right"
                    [iconSize]="{ width: 12, height: 12 }"
                    variant="accent"
                    size="xl"
                    gap="gap-4"
                    (buttonClick)="onCreateNewUser()" />
            }
        </div>
    </ng-template>
    <!-- Users stats -->
    <div class="users__stats">
        @for (stat of usersStats(); track $index) {
            <app-stats-card
                [statsData]="stat"
                [hasTotal]="true"
                [isLoading]="isLoadingUserStats() || usersStats().length === 0"></app-stats-card>
        }
    </div>

    <!-- Users control -->
    <app-users-toolbar
        [selection]="selection()"
        (searchChange)="onSearchValueChange($event)"
        (toolbarActionChange)="onToolbarAction($event)" />

    @if (!canNavigateToUserDetails()) {
        <p class="users__detail-access-hint">
            User profile details can only be opened by Super Admins.
        </p>
    }

    <!-- Users table -->
    <div class="users__table main-table-container">
        <app-table
            [data]="usersData()"
            [columns]="usersTableColumns"
            [totalDataLength]="totalUsersCount()"
            [loading]="
                (!isPaginating() && isLoadingUsers()) ||
                isSearchingUsers() ||
                isResolvingRoles() ||
                isResolvingCreatedBy()
            "
            [isColumnFiltering]="
                isColumnFiltering() || isResolvingRoles() || isResolvingCreatedBy()
            "
            [loadingOverlay]="isPaginating()"
            tableTitle="Users"
            [hasCheckBox]="false"
            [filterEnabled]="false"
            [showColumnSettings]="false"
            [tableHeight]="'auto'"
            [pageSize]="pageSize"
            (cellClick)="onCellClick($event)"
            (selectionChange)="onSelectionChange($event)"
            (actionClick)="onActionClick($event)"
            (showMoreRequested)="onShowMoreRequested()"
            (showLessRequested)="onShowLess()"
            (tableStateChange)="onTableStateChange($event)">
            <ng-template ntvTableCell="createdAt" let-row="row">
                {{ row.createdAt | date: 'MMMM dd, yyyy' }}
            </ng-template>
        </app-table>
    </div>
</div>

<!-- Delete Confirmation Modal -->
@if (showDeleteConfirmationModal()) {
    <app-confirmation-modal
        [isVisible]="showDeleteConfirmationModal()"
        [isLoading]="isDeletingUsers()"
        [showCancelButton]="true"
        size="small"
        [type]="'warning'"
        [title]="'Confirm Deleting User'"
        [message]="resolveDeleteMessage()"
        [confirmText]="'Delete'"
        cancelText="Cancel"
        (confirm)="onConfirmDelete()"
        (cancel)="closeModal()"
        (modalClose)="closeModal()" />
}

<!-- Successful Deletion Modal -->
@if (showSuccessDeleteModal()) {
    <app-confirmation-modal
        [isVisible]="showSuccessDeleteModal()"
        size="small"
        type="success"
        [title]="'Deletion Success'"
        [message]="'User has been successfully deleted'"
        [confirmText]="'Close'"
        (confirm)="showSuccessDeleteModal.set(false)"
        (modalClose)="showSuccessDeleteModal.set(false)" />
}

<!-- User Creation Success Modal -->
@if (showSuccessCreationModal()) {
    <app-confirmation-modal
        [isVisible]="showSuccessCreationModal()"
        size="small"
        type="success"
        [title]="'User Created Successfully'"
        [message]="'The user has been successfully created and added to the system.'"
        [confirmText]="'Close'"
        (confirm)="dismissSuccessCreationModal()"
        (modalClose)="dismissSuccessCreationModal()" />
}
